import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FullReloadService {
    private isFullReloadRequired: boolean = false;

    public get fullReloadRequired(): boolean {
        return this.isFullReloadRequired;
    }

    setFullReloadRequired(): void {
        this.isFullReloadRequired = true;
    }
}
